module.exports = __webpack_public_path__ + "img/voice-call-icon-calllog.93ab3103.svg";